import React from 'react';
import BaseModal from './BaseModal';
import Button from "../button/Button";

const ConfirmModal = ({ item = {}, isOpen, onCancel, onConfirm }) => {
    const message = item.confirmMessage ? item.confirmMessage : "Are you sure you want to proceed?";
    return (
        <BaseModal isOpen={isOpen}>
            <div className="modal-body p-5 my-5">
                <div className="text-center mb-4">
                    {message}
                </div>
                <div className="d-flex align-items-center justify-content-center column-gap-3">
                    <Button className="bg-success bg-opacity-75 bg-opacity-100-hover" type="button" onClick={() => onConfirm(item)}>Confirm</Button>
                    <Button className="bg-secondary bg-opacity-25 bg-opacity-50-hover" type="button" onClick={onCancel}>Cancel</Button>
                </div>
            </div>
        </BaseModal>
    );
};

export default ConfirmModal;
